import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/triangle.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rotate-180 w-full",
  alt: "",
  srcset: ""
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { onMounted, onUnmounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollToTop',
  setup(__props) {

const visible = ref(false)
const dealScrollFunc = () => {
  if (document.documentElement.scrollTop > 200) {
    visible.value = true
  } else {
    visible.value = false
  }
}
onMounted(() => {
  document.addEventListener('scroll', dealScrollFunc)
})
onUnmounted(() => {
  document.removeEventListener('scroll', dealScrollFunc)
})
const toTop = () => {
  window.scrollTo(0, 0)
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "w-[35px] h-[35px] bg-opWhite fixed bottom-[10%] right-[20px] cursor-pointer border rounded-[50%]",
    onClick: toTop
  }, _hoisted_2, 512)), [
    [_vShow, visible.value]
  ])
}
}

})